function HomePolicyHolderHandler(Util, publicIDTransformer) {

	
	function handle(quoteRequest, userInput) {
		
		
		return quoteRequest;
	}

    return {
		handle: handle
	}
};